"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ValuesEditor = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _NumberValuesEditor = _interopRequireDefault(require("../NumberValuesEditor"));

var _StringValuesEditor = require("../StringValuesEditor");

var _propTypes2 = require("../../shared/propTypes");

var _messages = _interopRequireDefault(require("./messages"));

var _options = require("../../shared/enums/options");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var optionType = _propTypes["default"].shape(_propTypes2.optionShape);

var propertyType = _propTypes["default"].shape(_propTypes2.propertyConditionAttributeShape);

var isOptionType = function isOptionType(option) {
  return option.type === _options.STRING;
};

var isNumberType = function isNumberType(option) {
  return option.type === _options.NUMBER;
};

var ValuesEditor = function ValuesEditor(_ref) {
  var condition = _ref.condition,
      attributes = _ref.attributes,
      allowFormulas = _ref.allowFormulas,
      updateConditionValues = _ref.updateConditionValues;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var selectedAttribute = attributes[condition.attribute];
  var editor = null;

  if (!selectedAttribute) {
    editor = null;
  } else if (isOptionType(selectedAttribute)) {
    editor =
    /*#__PURE__*/
    _react["default"].createElement(_StringValuesEditor.StringValuesEditor, {
      values: condition.values,
      attribute: selectedAttribute,
      onValuesChanged: updateConditionValues
    });
  } else if (isNumberType(selectedAttribute, condition)) {
    editor =
    /*#__PURE__*/
    _react["default"].createElement(_NumberValuesEditor["default"], {
      selectedAttribute: selectedAttribute,
      selectedOperator: condition.operator,
      condition: condition,
      attributes: attributes,
      allowFormulas: allowFormulas,
      onUpdateConditionValues: updateConditionValues
    });
  } else {
    editor =
    /*#__PURE__*/
    _react["default"].createElement("div", null,
    /*#__PURE__*/
    _react["default"].createElement("h4", null, formatMessage(_messages["default"].unspecifiedType)));
  }

  return editor;
};

exports.ValuesEditor = ValuesEditor;
ValuesEditor.propTypes = {
  condition: _propTypes["default"].shape(_propTypes2.constraintConditionShape).isRequired,
  attributes: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([optionType, propertyType])).isRequired,
  allowFormulas: _propTypes["default"].bool,
  updateConditionValues: _propTypes["default"].func.isRequired
};
ValuesEditor.defaultProps = {
  allowFormulas: true
};
var _default = ValuesEditor;
exports["default"] = _default;